import headerScrollWhite from '../partials/headerWhite';

export default {
  init() {
    window.onscroll = headerScrollWhite;
  },

  // JavaScript to be fired on all pages, after page specific JS is fired
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/servicesPage.js